import { useState } from "react";

import {
    AssetCategory,
    CommunityAssetImageField,
} from "@features/uploadAsset";

import { Text } from "@fragments";

export default function Asset({ configRef, communityId, onUploadingChange }) {
    const [photo, setPhoto] = useState(configRef.current.photo || null);

    function handleChange(url) {
        configRef.current.photo = url;
        setPhoto(url);
    }

    return (
        <div className="banner-add mt-2">
            <Text.span value="Imagem" />

            <CommunityAssetImageField
                communityId={communityId}
                category={AssetCategory.GROUP_POST}
                value={photo}
                onChange={handleChange}
                onUploadingChange={onUploadingChange}
                aspectRatio={1}
                size={120}
                imageMaxWidth={1080}
                title="Redimensionar post"
                displayTitle={false}
            />
        </div>
    );
}
